import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useSelector } from 'react-redux';

const Navdata = () => {
    const navigate = useNavigate();

    const user = useSelector((state) => state.login.user);

    //state data
    const [isDashboard, setIsDashboard] = useState(false);
    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    function updateIconSidebar(e) {
        if (e && e.target && e.target.getAttribute("subitems")) {
            const ul = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("subitems");
                if (document.getElementById(id))
                    document.getElementById(id).classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
    }, [
        navigate,
        iscurrentState,
        isDashboard,
    ]);

    const menuItems = [];
    const configMenuItems = [];

    menuItems.push({
        id: "dashboard",
        label: "Dashboard",
        icon: "ri-dashboard-2-line",
        link: "/#"
    });

    if(user.defaultModule === "IDI") {
        if(user.canViewIdiProject) {
            if(user.canViewIdiInspection) {
                menuItems.push({
                    id: "SearchIdiInspectionDashboard",
                    label: "Dashboard (INR)",
                    icon: "ri-dashboard-2-line",
                    link: "/idi-inspection-dashboard"
                });
            }
        }
    }

    if(user) {
        //add request
        if(user.canAddRequest && user.defaultModule === "Ticketing") {
            menuItems.push({
                id: "CreateRequest",
                label: "Add Ticket",
                icon: "ri-add-circle-line",
                link: "/request-add"
            });
        }

        if(user.canAddRequest && user.defaultModule === "ISO") {
            menuItems.push({
                id: "CreateIsoRequest",
                label: "Add Ticket",
                icon: "ri-add-circle-line",
                link: "/iso-request-add"
            });
        }
		
        if(user.canAddIneRequest && user.defaultModule === "INE") {
            menuItems.push({
                id: "CreateIneRequest",
                label: "Add Ticket",
                icon: "ri-add-circle-line",
                link: "/ine-request-add"
            });
        }

        if(user.canAddIdiProject && user.defaultModule === "IDI") {
            menuItems.push({
                id: "CreateIdiProject",
                label: "Add Project",
                icon: "ri-add-circle-line",
                link: "/idi-project-add"
            });
        }
        
        if(user.canAddClientDocumentRequest && user.defaultModule === "IDI") {
            menuItems.push({
                id: "CreateIdiRequest",
                label: "Add Ticket",
                icon: "ri-add-circle-line",
                link: "/client-document-request-add"
            });
        }

        //search requests
        if(user.defaultModule === "ISO") {
            menuItems.push({
                id: "SearchIsoRequests",
                label: "Tickets",
                icon: "ri-search-line",
                link: "/iso-requests"
            });

            menuItems.push({
                id: "NotifySearchRequests",
                label: "Upcoming Expiry",
                icon: "ri-search-line",
                link: "/iso-request-notifications"
            });
        }
        else if(user.defaultModule === "INE") {
            menuItems.push({
                id: "SearchIneTickets",
                label: "Tickets",
                icon: "ri-search-line",
                link: "/ine-requests"
            });
        }
        else if(user.defaultModule === "IDI") {
            if(user.canViewIdiProject) {
                menuItems.push({
                    id: "SearchIdiProjects",
                    label: "Projects",
                    icon: "ri-search-line",
                    link: "/idi-projects"
                });
            }

            if(user.canViewIdiInspection) {
                menuItems.push({
                    id: "SearchIdiInspections",
                    label: "Inspections",
                    icon: "ri-search-line",
                    link: "/idi-inspections"
                });
            }

            if(user.canViewClientDocumentRequest) {
                menuItems.push({
                    id: "SearchIdiRequests",
                    label: "Tickets",
                    icon: "ri-search-line",
                    link: "/client-document-requests"
                });
            }
        }
        else if(user.defaultModule === "Ticketing") {
            menuItems.push({
                id: "SearchRequests",
                label: "Tickets",
                icon: "ri-search-line",
                link: "/requests"
            });
        
            if(user.canViewReview) {
                menuItems.push({
                    id: "SearchReviews",
                    label: "Reviews",
                    icon: "ri-search-line",
                    link: "/revw-requests"
                });
            }
            
            if(user.canViewShipmentCertificate) {
                menuItems.push({
                    id: "SearchShipmentCertificates",
                    label: "Shipment Certificates",
                    icon: "ri-search-line",
                    link: "/scoc-requests"
                });
            }

            if(user.canViewProductCertificate) {
                menuItems.push({
                    id: "SearchProductCertificates",
                    label: "Product Certificates",
                    icon: "ri-search-line",
                    link: "/pcoc-requests"
                });
            }
        
            if(user.canViewFactoryAudit) {
                menuItems.push({
                    id: "SearchFactoryAudit",
                    label: "Factory Audits",
                    icon: "ri-search-line",
                    link: "/fa-requests"
                });
            }
        
            if(user.canViewCosmetic) {
                menuItems.push({
                    id: "SearchCosmetic",
                    label: "Cosmetics",
                    icon: "ri-search-line",
                    link: "/cos-requests"
                });
            }

            if(user.canViewProcessedFood) {
                menuItems.push({
                    id: "SearchProcessedFood",
                    label: "Processed Food",
                    icon: "ri-search-line",
                    link: "/processed-food-requests"
                });
            }

            if(user.canViewFreshFood) {
                menuItems.push({
                    id: "SearchFreshFood",
                    label: "Fresh Food",
                    icon: "ri-search-line",
                    link: "/fresh-food-requests"
                });
            }

            if(user.canViewChilledFood) {
                menuItems.push({
                    id: "SearchChilledFood",
                    label: "Chilled Food",
                    icon: "ri-search-line",
                    link: "/chilled-food-requests"
                });
            }

            if(user.canViewInspection) {
                menuItems.push({
                    id: "SearchInspections",
                    label: "Inspections",
                    icon: "ri-search-line",
                    link: "/ins-requests"
                });
            }

            if(user.canViewSampling) {
                menuItems.push({
                    id: "SearchSamplings",
                    label: "Samplings",
                    icon: "ri-search-line",
                    link: "/samp-requests"
                });
            }

            if(user.canViewNotify) {
                menuItems.push({
                    id: "NotifySearchRequests",
                    label: "Upcoming Expiry",
                    icon: "ri-search-line",
                    link: "/request-notifications"
                });
            }

            if(user.canViewCalendar) {
                menuItems.push({
                    id: "TicketCalendar",
                    label: "Inspector Calendar",
                    icon: "ri-calendar-2-line",
                    link: "/request-calendar"
                });
            }

            if(user.canViewLabReport) {
                menuItems.push({
                    id: "LabReport",
                    label: "Lab Reports",
                    icon: "ri-search-eye-line",
                    link: "/lab-reports"
                });
            }
        }

        //config items
        if(user.canManageCompany) {
            configMenuItems.push({
                id: "CompanySearch",
                label: "Companies",
                icon: "ri-apps-2-line",
                link: "/companies"
            });
        }

        if(user.canManageUser) {
            configMenuItems.push({
                id: "UserSearch",
                label: "Users",
                icon: "ri-apps-2-line",
                link: "/users"
            });

            configMenuItems.push({
                id: "RoleSearch",
                label: "Roles",
                icon: "ri-apps-2-line",
                link: "/roles"
            });
        }

        if(user.canManageInspector && user.defaultModule === "Ticketing") {
            configMenuItems.push({
                id: "InspectorSearch",
                label: "Inspectors",
                icon: "ri-apps-2-line",
                link: "/inspectors"
            });
        }

        if(user.canManageGroup && user.defaultModule === "Ticketing") {
            configMenuItems.push({
                id: "GroupSearch",
                label: "Groups",
                icon: "ri-apps-2-line",
                link: "/groups"
            });
        }

        if(user.canManageAuditor && user.defaultModule === "ISO") {
            configMenuItems.push({
                id: "AuditorSearch",
                label: "Auditors",
                icon: "ri-apps-2-line",
                link: "/auditors"
            });
        }

        if(user.canManageTechnicalReviewer && user.defaultModule === "ISO") {
            configMenuItems.push({
                id: "TechnicalReviewerSearch",
                label: "Technical Reviewers",
                icon: "ri-apps-2-line",
                link: "/technical-reviewers"
            });
        }

        if(user.canManageCustomer && (user.defaultModule === "Ticketing" || user.defaultModule === "ISO" || user.defaultModule === "INE")) {
            configMenuItems.push({
                id: "CustomerSearch",
                label: "Customers",
                icon: "ri-apps-2-line",
                link: "/customers"
            });
        }

        if(user.canManageImporter && user.defaultModule === "Ticketing") {
            configMenuItems.push({
                id: "ImporterSearch",
                label: "Importers",
                icon: "ri-apps-2-line",
                link: "/vendor-search/importer"
            });
        }

        if(user.canManageExporter && user.defaultModule === "Ticketing") {
            configMenuItems.push({
                id: "ExporterSearch",
                label: "Exporters",
                icon: "ri-apps-2-line",
                link: "/vendor-search/exporter"
            });
        }
        
        if(user.canManageManufacturer && user.defaultModule === "Ticketing") {
            configMenuItems.push({
                id: "ManufacturerSearch",
                label: "Manufacturers",
                icon: "ri-apps-2-line",
                link: "/vendor-search/manufacturer"
            });
        }
        
        if(user.canManageProduct && user.defaultModule === "Ticketing") {
            configMenuItems.push({
                id: "ProductSearch",
                label: "Products",
                icon: "ri-apps-2-line",
                link: "/products"
            });
        }

        if(user.canManageIneInspector && user.defaultModule === "INE") {
            configMenuItems.push({
                id: "InspectorSearch",
                label: "Inspectors",
                icon: "ri-apps-2-line",
                link: "/ine-inspectors"
            });
        }

        if(user.canManageTestingScope && user.defaultModule === "INE") {
            configMenuItems.push({
                id: "TestingScopeSearch",
                label: "Scopes",
                icon: "ri-apps-2-line",
                link: "/ine-scopes"
            });
        }

        if(user.canManageTestingEquipment && user.defaultModule === "INE") {
            configMenuItems.push({
                id: "TestingEquipmentSearch",
                label: "Equipments",
                icon: "ri-apps-2-line",
                link: "/ine-equipments"
            });
        }

        if(user.canManageCalendar && user.defaultModule === "INE") {
            configMenuItems.push({
                id: "IneCalendar",
                label: "Calendar",
                icon: "ri-apps-2-line",
                link: "/ine-calendar"
            });
        }

        if(user.canManageCalendar && user.defaultModule === "IDI") {
            configMenuItems.push({
                id: "IdiCalendar",
                label: "Calendar",
                icon: "ri-apps-2-line",
                link: "/idi-calendar"
            });
        }

        if(user.canManageIdiCustomer && user.defaultModule === "IDI") {
            configMenuItems.push({
                id: "IdiCustomer",
                label: "Customers",
                icon: "ri-apps-2-line",
                link: "/idi-customers/customer"
            });

            configMenuItems.push({
                id: "IdiOwners",
                label: "Owners",
                icon: "ri-apps-2-line",
                link: "/idi-customers/owner"
            });
        }

        if(user.canManageIdiInspector && user.defaultModule === "IDI") {
            configMenuItems.push({
                id: "IdiInspector",
                label: "Inspectors",
                icon: "ri-apps-2-line",
                link: "/idi-inspectors"
            });
        }

        // configMenuItems.push({
        //     id: "IdiImport",
        //     label: "Import",
        //     icon: "ri-apps-2-line",
        //     link: "/idi-import"
        // });
    }
    
    if(configMenuItems.length > 0) {
        menuItems.push({
            label: "Configurations",
            isHeader: true,
        });

        configMenuItems.forEach((item) => {
            menuItems.push(item);
        });
    }

    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;